import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LottieAnimation from '@/components/behaviours/LottieAnimation';
import Icon from '@/components/atoms/Icon';
import animationData from './LottieVoiceAssistant.json';

import './VoiceAssistant.scss';

const propTypes = {
    iconSize: PropTypes.string,
};
const defaultProps = {
    iconSize: null,
};

const VoiceAssistant = ({ iconSize, ...props }) => {
    const classes = classNames({
        [`${iconSize}`]: iconSize !== null,
    });

    return (
        <Icon className={classes} iconName="VoiceAssistant" {...props}>
            <LottieAnimation loop autoplay animationData={animationData} />
        </Icon>
    );
};

VoiceAssistant.propTypes = propTypes;
VoiceAssistant.defaultProps = defaultProps;

export default VoiceAssistant;
